import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CookiebotComponent } from './cookiebot.component';

const routes: Routes = [{ path: '', component: CookiebotComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CookiebotRoutingModule { }
